export default {
  props: {
    banner: {
      type: Object,
      required: true,
    },

    button: {
      type: Object,
      required: false,
    },
  },
}
